import {
    Card,
    Flex, Space
} from "antd";
import React, {useCallback, useState} from "react";
import {aiChainPrompt} from "../../Prompt";
import TextArea from "antd/es/input/TextArea";
import {ModelsMenu} from "../../components/ModelsMenu";
import Markdown from "react-markdown";
import {GenButton} from "../../components/GenButton";
import {generateFreeGenerationPrompt} from "../ToolsPrompts";

export const TextGenerator = (props: {
    onItemClick?: (item: any) => void
}) => {
    const [description, setDescription] = useState("");
    const [texts, setTexts] = useState<{ text: string, user: boolean }[]>([]);
    const [height, setHeight] = useState(0);


    const elementRef = useCallback((node: any) => {
        if (!node) return;
        const resizeObserver = new ResizeObserver(() => {
            setHeight(node.getBoundingClientRect().height);
        });
        resizeObserver.observe(node);
    }, []);

    return (
        <Flex gap={16} style={{width: "100%", minHeight: 600, maxHeight: 800}}>
            <Flex vertical={true} gap={10} style={{height: "100%", width: 300}} ref={elementRef}>
                <ModelsMenu/>
                <Card title={"Prompt"}>
                    <TextArea placeholder={"Ask anything"} value={description} rows={15}
                              onChange={(e) => setDescription(e.target.value)}/>
                </Card>
                <GenButton
                    style={{width: "100%"}}
                    type={'primary'}
                    actions={[{
                        key: "1",
                        title: "Generate",
                        action: async (model: string, projectId: string) => {
                            let txts = [...texts, {text: description, user: true}]
                            setTexts(txts)
                            return aiChainPrompt({
                                projectId: projectId,
                                prompt: generateFreeGenerationPrompt({prompt: description}),
                                model: model,
                            }).then((response) => {
                                txts = [...txts, {text: response, user: false}]
                                setTexts(txts)
                            }).catch((e) => {
                                console.log(e)
                            })
                        }
                    }]}/>
            </Flex>
            <Flex vertical={true} gap={10} align={'start'} style={{
                height: `calc(${height}px)`,
                overflowY: 'auto', scrollbarWidth: "none",
                flexGrow: "1",
            }}>
                {texts.map((text, index) =>
                    <div style={{
                        borderRadius: 6,
                        background: text.user ? '#fff' : '#eee',
                        border: '1px solid ' + (text.user ? '#eee' : '#fff'),
                        padding: 10,
                        width: 'auto',
                        alignSelf: text.user ? 'flex-end' : 'flex-start'
                    }} onClick={() => props.onItemClick?.(text.text)}>
                        <Markdown className={"markdown-text simple"}>{text.text}</Markdown>
                    </div>
                )}
            </Flex>
        </Flex>
    );
}